// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"45d91e03","453":"c65b3a7a","553":"362534f8","977":"ee43813b"}[chunkId] + ".chunk.js";
};